import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Loader from '@amzn/meridian/loader';
import styled from '@emotion/styled';
const LoaderWrapper = styled.div `
  transform: scale(1.3);
`;
// Meridian doesn't have a size between small and medium for their loader,
// so we scale the small loader to create a "smedium" size
export const SmediumLoader = () => (_jsx(LoaderWrapper, { children: _jsx(Loader, { size: "small", "data-testid": "loading-spinner" }) }));
